// industrydata.js
const IndustryData = [
  {
    id: "retail",
    name: "Retail",
    badge: "Built for All Types of Retail Businesses",
    description:
      "Manage your retail shop effortlessly with fast billing, smart inventory tracking, GST-compliant invoices, and real-time business insights.",
    testimonial: {
      text: "Billing is now faster, inventory is always accurate, and GST reports are ready in minutes.",
      author: "Amit Traders, Delhi",
      image: "/assets/img/message4.png",
    },
    mockupType: "billing",
    image: "/assets/img/features-img/retail-1.png",
    benefits: [
      "Fast and easy billing for walk-in customers",
      "Real-time inventory tracking with low-stock alerts",
      "GST-ready invoices and tax reports",
      "Multiple payment modes including UPI and cards",
      "Daily profit, sales, and expense tracking",
      "Works online and offline across devices",
    ],
    features: [
      {
        title: "Quick Billing & Invoicing",
        desc: "Generate professional invoices in seconds, reducing customer wait time and improving checkout efficiency.",
        image: "/assets/img/features-img/retail-2.png",
        points: [
          "One-click invoice creation",
          "Supports cash, UPI, and card payments",
          "Thermal & regular printer compatible",
        ],
      },
      {
        title: "Smart Inventory Management",
        desc: "Track stock levels automatically after each sale or purchase to avoid shortages or overstocking.",
        image: "/assets/img/features-img/retail-3.png",
        points: [
          "Auto stock updates",
          "Instant low-stock alerts",
          "Avoid over-selling and stockouts",
        ],
      },
      {
        title: "Barcode & QR Code Billing",
        desc: "Speed up checkout using barcode or QR code scanning for fast and accurate billing.",
        image: "/assets/img/features-img/retail-4.png",
        points: [
          "Fast and error-free scanning",
          "Easy barcode generation",
          "Supports mobile scanning",
        ],
      },
      {
        title: "GST Billing & Reports",
        desc: "Generate GST-compliant invoices and tax reports automatically, simplifying tax filing.",
        image: "/assets/img/features-img/retail-5.png",
        points: [
          "Automatic GST calculation",
          "GSTR-ready reports",
          "Easy export for accountants",
        ],
      },
      {
        title: "Multi-Device Sync",
        desc: "Access your retail shop data from any device, ensuring seamless business operations across multiple users.",
        image: "/assets/img/features-img/retail-6.png",
        points: [
          "Real-time data synchronization",
          "Multi-user access",
          "Secure cloud backup",
        ],
      },
      {
        title: "WhatsApp Invoice Sharing",
        desc: "Send bills and payment reminders instantly via WhatsApp or SMS for faster collections.",
        image: "/assets/img/features-img/retail-7.png",
        points: [
          "One-tap invoice sharing",
          "Faster payment collection",
          "Enhanced customer experience",
        ],
      },
    ],
    capabilities: [
      {
        // icon: "💻",
        title: "Smart Dashboard",
        desc: "View sales, profit, and low-stock items at a glance",
      },
      {
        // icon: "📦",
        title: "Retail Inventory",
        desc: "Manage hundreds or thousands of items efficiently",
      },
      {
        // icon: "🧾",
        title: "GST-Compliant Billing",
        desc: "Automatic tax calculation and professional invoice generation",
      },
      {
        // icon: "📊",
        title: "Business Reports",
        desc: "Real-time sales, profit, and expense reports for better decision making",
      },
    ],
  },
  {
    id: "grocery",
    name: "Grocery",
    badge: "Specialized for Kirana & Grocery Stores",
    description:
      "Streamline grocery operations with expiry alerts, POS billing, loose item weighing, and GST compliance.",
    testimonial: {
      text: "Expiry alerts and fast billing have saved us from losses and long queues— a must-have for any kirana!",
      author: "FreshMart Kirana, Delhi",
      image: "/assets/img/message6.png",
    },
    mockupType: "pos",
    image: "/assets/img/features-img/grocery-1.png",
    benefits: [
      "Quick POS billing for high-volume checkouts",
      "Expiry and batch tracking to reduce wastage",
      "Weighing scale integration for loose items",
      "GST-compliant invoices in seconds",
      "Credit customer management with reminders",
      "Daily margin and sales insights",
    ],
    features: [
      {
        title: "Batch & Expiry Date Monitoring",
        desc: "Track batch numbers and expiry dates with automatic alerts.",
        image: "/assets/img/features-img/grocery-2.png",
        points: [
          "Near-expiry notifications",
          "Batch-specific inventory",
          "Reduce product wastage",
        ],
      },
      {
        title: "Barcode Scanning for Packed Goods",
        desc: "Scan products quickly to speed up billing and stock updates.",
        image: "/assets/img/features-img/grocery-3.png",
        points: [
          "Faster checkout",
          "Error-free scanning",
          "Inventory updates instantly",
        ],
      },
      {
        title: "Monthly Credit Billing for Regulars",
        desc: "Manage credit accounts and issue monthly bills automatically.",
        image: "/assets/img/features-img/grocery-4.png",
        points: [
          "Track customer credits",
          "Reduce manual errors",
          "Send reminders",
        ],
      },
      {
        title: "Multi-branch Stock Synchronization",
        desc: "Ensure real-time stock updates across all branches.",
        image: "/assets/img/features-img/grocery-5.png",
        points: [
          "Accurate stock visibility",
          "Automatic updates",
          "Branch-specific tracking",
        ],
      },
      {
        title: "Automated Low-stock Reorder Suggestions",
        desc: "Never run out of essentials with smart reorder notifications.",
        image: "/assets/img/features-img/retail-6.png",
        points: [
          "Custom reorder thresholds",
          "Email/SMS alerts",
          "Stock replenishment made easy",
        ],
      },
      {
        title: "Seamless WhatsApp Bill Sharing",
        desc: "Send bills instantly to customers via WhatsApp.",
        image: "/assets/img/features-img/retail-7.png",
        points: [
          "Quick invoice delivery",
          "Enhances customer experience",
          "Reduces printing costs",
        ],
      },
    ],
    capabilities: [
      {
        // icon: "💻",
        title: "POS Dashboard",
        desc: "Real-time view of sales, dues, and stock levels",
      },
      {
        // icon: "📦",
        title: "Perishable Tracking",
        desc: "Prevent losses with smart expiry management",
      },
      {
        // icon: "🧾",
        title: "Fast Invoicing",
        desc: "Generate bills instantly with tax automation",
      },
      {
        // icon: "📊",
        title: "Profit Analytics",
        desc: "Track margins per item and category",
      },
    ],
  },
  {
    id: "pharmacy",
    name: "Pharmacy",
    badge: "Specialized for Medical Shops & Pharmacies",
    description:
      "Optimize pharmacy management with batch tracking, GST billing, prescription handling, and stock alerts.",
    testimonial: {
      text: "Batch tracking and instant billing have eliminated expiry issues and sped up our service!",
      author: "HealthPlus Pharmacy, Pune",
      // image: "/assets/img/messages-3.jpg",
      image: "/assets/img/message1.png",
    },
    mockupType: "dashboard",
    image: "/assets/img/features-img/pharmacy-1.png",
    benefits: [
      "Automatic expiry alerts to avoid losses",
      "Fast search and barcode billing for medicines",
      "GST and Schedule H/H1 compliance",
      "Easy prescription upload and records",
      "Supplier and reorder management",
      "Detailed sales and profit reports",
    ],
    features: [
      {
        title: "Batch & Expiry Control",
        desc: "Track all medicine batches with automatic expiry notifications.",
        image: "/assets/img/features-img/pharmacy-2.png",
        points: [
          "Avoid expired stock",
          "Batch-specific tracking",
          "Alerts for low-stock medicines",
        ],
      },
      {
        title: "Prescription Integration & Tracking",
        desc: "Upload and manage prescriptions for accurate dispensing.",
        image: "/assets/img/features-img/pharmacy-3.png",
        points: [
          "Track patient prescriptions",
          "Reduce dispensing errors",
          "Maintain records digitally",
        ],
      },
      {
        title: "MRP/PTR/PTS Auto-calculation",
        desc: "Automatically calculate medicine pricing based on applicable rates.",
        image: "/assets/img/features-img/pharmacy-4.png",
        points: [
          "Auto tax calculations",
          "Price margin tracking",
          "Faster billing",
        ],
      },
      {
        title: "Party-wise Purchase Ledgers",
        desc: "Maintain ledger for each supplier and track purchases efficiently.",
        image: "/assets/img/features-img/retail-5.png",
        points: [
          "Supplier-wise tracking",
          "Easy audit trail",
          "Purchase history available",
        ],
      },
      {
        title: "Comprehensive GST & Analytics Reports",
        desc: "Generate GST-ready invoices and detailed pharmacy reports.",
        image: "/assets/img/features-img/retail-3.png",
        points: [
          "Tax compliance made easy",
          "Profit analysis",
          "Trend insights",
        ],
      },
      {
        title: "Fast Barcode Billing",
        desc: "Scan medicines quickly for instant billing.",
        image: "/assets/img/features-img/retail-4.png",
        points: [
          "Error-free checkout",
          "Speed up customer service",
          "Update inventory in real-time",
        ],
      },
    ],
    capabilities: [
      {
        // icon: "💻",
        title: "Pharmacy Dashboard",
        desc: "Daily sales, expiry alerts, and stock overview",
      },
      {
        // icon: "📦",
        title: "Medicine Inventory",
        desc: "Batch-wise tracking with smart reminders",
      },
      {
        // icon: "🧾",
        title: "Compliant Invoicing",
        desc: "GST-ready formats for pharma compliance",
      },
      {
        // icon: "📊",
        title: "Business Insights",
        desc: "Top drugs, profits, and trend analysis",
      },
    ],
  },
  {
    id: "jewellery",
    name: "Jewellery",
    badge: "Complete Jewellery Billing & Inventory Solution",
    description:
      "Run your jewellery business effortlessly with accurate billing, real-time inventory, weight & karat tracking, GST compliance, and smart POS tools.",
    testimonial: {
      text: "Accurate billing, live gold rates, and inventory tracking have made our jewellery operations faster and more reliable.",
      author: "Trusted Jewellery Store, India",
      image: "/assets/img/message5.png",
    },
    mockupType: "dashboard",
    image: "/assets/img/features-img/jewellery-1.png",

    stats: [
      { label: "Bills Auto Processed", value: "1 Cr+" },
      { label: "Billing Accuracy", value: "99.9%" },
      { label: "Time Saved Daily", value: "30+ mins" },
    ],

    benefits: [
      "Weight, karat & stone-wise inventory tracking",
      "Automatic making & labour charge calculation",
      "GST & HSN compliant jewellery billing",
      "Old gold exchange & scheme management",
      "Barcode tagging for unique jewellery items",
      "Real-time gold & silver rate support",
    ],

    features: [
      {
        title: "Karat & Weight-Based Inventory",
        desc: "Track every jewellery item by weight, purity, and stone details with real-time stock updates.",
        image: "/assets/img/features-img/retail-1.png",
        points: [
          "Gold, silver & diamond tracking",
          "Design & category-wise stock view",
          "Low stock alerts",
        ],
      },
      {
        title: "Making, Labour & Stone Charges",
        desc: "Automatically calculate making charges, wastage, labour costs, and stone values during billing.",
        image: "/assets/img/features-img/grocery-3.png",
        points: [
          "Auto charge calculation",
          "Stone-wise pricing",
          "Error-free invoices",
        ],
      },
      {
        title: "Old Gold Exchange Management",
        desc: "Handle old jewellery exchange with instant valuation, deductions, and transparent adjustments.",
        image: "/assets/img/features-img/jewellery-1.png",
        points: [
          "Quick valuation",
          "Exchange & scheme tracking",
          "Secure audit history",
        ],
      },
      {
        title: "Barcode & Tag Management",
        desc: "Generate unique barcodes and tags for every jewellery item for faster billing and verification.",
        image: "/assets/img/features-img/retail-4.png",
        points: [
          "Unique item identification",
          "Fast POS billing",
          "Reduced manual errors",
        ],
      },
      {
        title: "Customer Advances & Schemes",
        desc: "Manage customer advances, gold saving schemes, instalments, and special offers in one place.",
        image: "/assets/img/features-img/grocery-2.png",
        points: [
          "Advance payment tracking",
          "Scheme maturity alerts",
          "Customer-wise reports",
        ],
      },
      {
        title: "Hallmark & GST Compliance",
        desc: "Maintain digital hallmark records and generate GST-compliant invoices with proper HSN codes.",
        image: "/assets/img/features-img/retail-4.png",
        points: [
          "Hallmark record storage",
          "GST-ready billing",
          "Audit-friendly documentation",
        ],
      },
    ],

    posFeatures: [
      "Weighing machine integration",
      "Automatic price calculation",
      "Instant inventory deduction",
      "Thermal printer support",
      "Fast & smooth checkout experience",
    ],

    capabilities: [
      {
        // icon: "💻",
        title: "Jewellery Dashboard",
        desc: "Live rates, sales & inventory overview",
      },
      {
        // icon: "📦",
        title: "Smart Inventory",
        desc: "Design, weight & purity-wise tracking",
      },
      {
        // icon: "🧾",
        title: "Advanced Billing",
        desc: "Making charges, GST & HSN automation",
      },
      {
        // icon: "📊",
        title: "Profit & Tax Reports",
        desc: "Margins, TDS/TCS & business insights",
      },
    ],
  },
  {
    id: "clothing",
    name: "Clothing",
    badge: "Smart Billing & Inventory for Garment Shops",
    description:
      "Run your garment and clothing business smarter with fast billing, barcode-based inventory, retail & wholesale pricing, and real-time business insights using AssistBuddi.",

    testimonial: {
      text: "Billing is faster, stock is always accurate, and managing retail and wholesale prices has become effortless.",
      author: "Leading Garment Store Owner, India",
      image: "/assets/img/message2.png",
    },

    mockupType: "dashboard",
    image: "/assets/img/features-img/clothing.png",

    stats: [
      { label: "Invoices Generated", value: "50L+" },
      { label: "Billing Accuracy", value: "99.9%" },
      { label: "Time Saved Daily", value: "25+ mins" },
    ],

    benefits: [
      "Retail & wholesale pricing in one system",
      "Barcode-based fast billing & inventory",
      "Size, color & design-wise stock tracking",
      "Discounts, offers & scheme management",
      "Real-time sales & profit insights",
      "Multi-store & multi-user support",
    ],

    features: [
      {
        title: "Retail & Wholesale Price Management",
        desc: "Set separate retail and wholesale prices for garments and manage margins effortlessly.",
        image: "/assets/img/features-img/retail-4.png",
        points: [
          "Customer-type based pricing",
          "Bulk price updates",
          "Margin & profit tracking",
        ],
      },
      {
        title: "Smart Discount & Offer Management",
        desc: "Create seasonal discounts, combo offers, and automatic bill-level discounts.",
        image: "/assets/img/features-img/grocery-2.png",
        points: [
          "Automatic discount application",
          "Offer performance tracking",
          "Improved customer retention",
        ],
      },
      {
        title: "Custom Billing & Invoicing",
        desc: "Generate professional invoices with your brand logo, tax details, and flexible pricing rules.",
        image: "/assets/img/features-img/grocery-3.png",
        points: [
          "Branded invoice formats",
          "GST & tax-ready bills",
          "Bulk & special order billing",
        ],
      },
      {
        title: "Order & Customer Management",
        desc: "Track customer orders from booking to delivery with real-time updates.",
        image: "/assets/img/features-img/grocery-4.png",
        points: [
          "Order status tracking",
          "Customer purchase history",
          "Advance & due management",
        ],
      },
      {
        title: "Barcode-Based Inventory Management",
        desc: "Manage garments by barcode, size, color, brand, and design with real-time stock updates.",
        image: "/assets/img/features-img/grocery-1.png",
        points: [
          "Fast POS scanning",
          "Automatic stock deduction",
          "Low stock alerts",
        ],
      },
      {
        title: "Multi-Store & Online Store Sync",
        desc: "Manage multiple garment stores and sync inventory with your online sales channels.",
        image: "/assets/img/features-img/grocery-2.png",
        points: [
          "Centralized store control",
          "Stock transfer between stores",
          "Online & offline sales sync",
        ],
      },
    ],

    inventoryFeatures: [
      "Size, color & variant tracking",
      "Low stock & reorder alerts",
      "Bulk item updates",
      "Multi-warehouse support",
    ],

    billingFeatures: [
      "Barcode & manual billing",
      "Multi-payment modes (UPI, card, cash)",
      "Print & share invoices",
      "Payment reminders for dues",
    ],

    reporting: [
      "Daily & monthly sales reports",
      "Product-wise performance",
      "Profit & margin analysis",
      "Cash flow tracking",
    ],

    capabilities: [
      {
        // icon: "🏬",
        title: "Garment Dashboard",
        desc: "Live sales, stock & profit overview",
      },
      {
        // icon: "👕",
        title: "Variant Inventory",
        desc: "Track by size, color & design",
      },
      {
        // icon: "🧾",
        title: "Fast Billing",
        desc: "Barcode-based POS billing",
      },
      {
        // icon: "📊",
        title: "Business Reports",
        desc: "Sales, cash flow & performance insights",
      },
    ],

    addons: [
      "Multi-user access with roles",
      "WhatsApp invoice sharing",
      "Online store integration",
      "Secure cloud data backup",
    ],
  },
  {
    id: "restaurant",
    name: "Restaurant",
    badge: "Smart Restaurant Billing & POS System",
    description:
      "Manage your restaurant effortlessly with AssistBuddi’s all-in-one billing software. Handle table orders, kitchen tickets, inventory, and payments seamlessly while reducing waste and improving service speed.",

    testimonial: {
      text: "Table billing, KOT handling, and inventory tracking are now smooth and error-free. Our service speed has improved significantly.",
      author: "Restaurant Owner, India",
      image: "/assets/img/message3.png",
    },

    mockupType: "dashboard",
    image: "/assets/img/features-img/restaurant-1.png",

    stats: [
      { label: "Orders Processed", value: "1 Cr+" },
      { label: "Order Accuracy", value: "99.9%" },
      { label: "Food Waste Reduced", value: "20%" },
    ],

    benefits: [
      "Fast table & takeaway billing",
      "Kitchen Order Ticket (KOT) system",
      "Real-time inventory & stock control",
      "Multi-kitchen & food court support",
      "Online & offline billing mode",
      "Actionable sales & profit insights",
    ],

    features: [
      {
        title: "Order Management",
        desc: "Manage dine-in, takeaway, and online orders from a single screen with real-time updates.",
        image: "/assets/img/features-img/retail-3.png",
        points: [
          "Live order tracking",
          "Quick order modifications",
          "Reduced billing errors",
        ],
      },
      {
        title: "Table Management",
        desc: "Assign, merge, and transfer tables easily while tracking running orders and bills.",
        image: "/assets/img/features-img/retail-6.png",
        points: [
          "Real-time table status",
          "Split & merge tables",
          "Smooth dine-in experience",
        ],
      },
      {
        title: "Kitchen Order Tickets (KOT)",
        desc: "Automatically send orders to kitchen screens or printers for faster preparation.",
        image: "/assets/img/features-img/restaurant-1.png",
        points: [
          "Instant KOT generation",
          "Custom kitchen routing",
          "Reduced preparation delays",
        ],
      },
      {
        title: "Multi-Kitchen & Food Court Setup",
        desc: "Manage multiple kitchens or counters with centralized billing and reporting.",
        image: "/assets/img/features-img/grocery-1.png",
        points: [
          "Kitchen-wise order flow",
          "Outlet-level reports",
          "Ideal for food courts",
        ],
      },
      {
        title: "Inventory & Recipe Management",
        desc: "Track ingredients, manage recipes, and reduce food wastage with smart inventory control.",
        image: "/assets/img/features-img/retail-6.png",
        points: [
          "Ingredient-level tracking",
          "Low stock & expiry alerts",
          "Waste reduction insights",
        ],
      },
      {
        title: "Digital Menu & Online Orders",
        desc: "Manage digital menus and online orders with real-time sync across platforms.",
        image: "/assets/img/features-img/retail-4.png",
        points: [
          "Instant menu updates",
          "Online & offline sync",
          "Better order accuracy",
        ],
      },
    ],

    billingFeatures: [
      "Quick POS billing",
      "Split bills & group orders",
      "Multiple payment modes",
      "Print & share invoices instantly",
    ],

    inventoryFeatures: [
      "Ingredient-level stock tracking",
      "Low stock & expiry alerts",
      "Purchase & vendor management",
      "Centralized inventory dashboard",
    ],

    reporting: [
      "Daily sales & order reports",
      "Item-wise & category-wise performance",
      "Profit & loss tracking",
      "Cash flow & payment reports",
    ],

    capabilities: [
      {
        // icon: "🍽️",
        title: "Restaurant Dashboard",
        desc: "Live orders, tables & revenue overview",
      },
      {
        // icon: "🧾",
        title: "Fast Billing POS",
        desc: "Table, takeaway & delivery billing",
      },
      {
        // icon: "👨‍🍳",
        title: "Kitchen Management",
        desc: "KOT & multi-kitchen coordination",
      },
      {
        // icon: "📊",
        title: "Business Reports",
        desc: "Sales, waste & profitability insights",
      },
    ],

    addons: [
      "Customer loyalty programs",
      "WhatsApp bill sharing",
      "Online ordering integration",
      "Multi-user access with roles",
      "Secure cloud data backup",
    ],

    access: ["Desktop billing", "Mobile app access", "Online & offline mode"],
  },
];

export default IndustryData;
